import {APP_NAMES} from '../constants';
import {
    circleSvg,
    circleActive,
    circleSelected,
    landingAppDestinationSvg,
    markerIconStandardSelectedSvg,
    standardMarkerIcon,
    standardMarkerIconHovered,
    landingAppPriceSvg,
} from '../svgDefs/markerSvgs';

export const landingAppDestination = 'landingAppDestination';
export const pointMarker = 'pointMarker';
export const markerIconStandard = 'markerIconStandard';
export const landingAppPrice = 'landingAppPrice';
export const markerIconStandardSelected = 'markerIconStandardSelected';
export const selectedPointMarker = 'selectedPointMarker';
export const landingAppPointMarker = 'landingAppPointMarker';
export const selectedLandingAppPointMarker = 'selectedLandingAppPointMarker';
export const externalHoveredStandardMarkerIcon =
    'externalHoveredStandardMarkerIcon';

const propertyIconQualifiers = (markers, appName) => {
    const qualifiers = {};
    if (document && appName === APP_NAMES.TRIPBOARDS) {
        markers.map((marker) => {
            const uuid =
                marker.lat && marker.lng
                    ? `${marker.lat}${marker.lng}`
                    : marker.id;
            const status = marker.initialStatus;
            const soldOut = status === 'sold_out';
            const loading = status === 'loading';
            if (soldOut) {
                const tripBoardSoldOutIcon = `
                <div class="price-marker-anchor price-marker-disabled">
                    <div class="price-marker-content">
                        <h5 class="price-marker-content-label">${marker.text}</h5>
                    </div>
                </div>`;

                const tripBoardSoldOutIconHighlighted = `
                <div class="price-marker-highlighted price-marker-anchor price-marker-disabled">
                    <div class="price-marker-content">
                        <h5 class="price-marker-content-label">${marker.text}</h5>
                    </div>
                </div>`;

                const wrappingTripBoardSoldOutIcon =
                    document.createElement('div');
                wrappingTripBoardSoldOutIcon.innerHTML = tripBoardSoldOutIcon;

                const wrappingTripBoardSoldOutIconHighlighted =
                    document.createElement('div');
                wrappingTripBoardSoldOutIconHighlighted.innerHTML =
                    tripBoardSoldOutIconHighlighted;

                qualifiers[`${uuid}`] = wrappingTripBoardSoldOutIcon;
                qualifiers[`hl#${uuid}`] =
                    wrappingTripBoardSoldOutIconHighlighted;
                return;
            }
            if (loading) {
                const tripBoardLoadingIcon = `
                <div class="price-marker-anchor price-marker-loading">
                    <div class="price-marker-content">
                        <div class="marker-loading-overlay">
                            <ul aria-hidden class="marker-loading-overlay__ul">
                                <li class="marker-loading-overlay__li marker-loading-overlay__li--1"></li>
                                <li class="marker-loading-overlay__li marker-loading-overlay__li--2"></li>
                                <li class="marker-loading-overlay__li marker-loading-overlay__li--3"></li>
                                <li class="marker-loading-overlay__li marker-loading-overlay__li--4"></li>
                            </ul>
                        </div>
                    </div>
                </div>`;

                const tripBoardLoadingIconHighlighted = `
                <div class="price-marker-highlighted price-marker-anchor price-marker-loading">
                    <div class="price-marker-content">
                        <div class="marker-loading-overlay">
                            <ul aria-hidden class="marker-loading-overlay__ul">
                                <li class="marker-loading-overlay__li marker-loading-overlay__li--1"></li>
                                <li class="marker-loading-overlay__li marker-loading-overlay__li--2"></li>
                                <li class="marker-loading-overlay__li marker-loading-overlay__li--3"></li>
                                <li class="marker-loading-overlay__li marker-loading-overlay__li--4"></li>
                            </ul>
                        </div>
                    </div>
                </div>`;

                const wrappingTripBoardLoadingElement =
                    document.createElement('div');
                wrappingTripBoardLoadingElement.innerHTML =
                    tripBoardLoadingIcon;

                const wrappingTripBoardLoadingElementHighlighted =
                    document.createElement('div');
                wrappingTripBoardLoadingElementHighlighted.innerHTML =
                    tripBoardLoadingIconHighlighted;

                qualifiers[`${uuid}`] = wrappingTripBoardLoadingElement;
                qualifiers[`hl#${uuid}`] =
                    wrappingTripBoardLoadingElementHighlighted;
                return;
            }
            const tripBoardPriceIcon = `
            <div class="price-marker-anchor">
                <div class="price-marker-content">
                    <h5 class="price-marker-content-label">${marker.text}</h5>
                </div>
            </div>`;

            const tripBoardPriceIconHighlighted = `
            <div class="price-marker-highlighted price-marker-anchor">
                <div class="price-marker-content">
                    <h5 class="price-marker-content-label">${marker.text}</h5>
                </div>
            </div>`;

            const wrappingTripBoardPriceIcon = document.createElement('div');
            wrappingTripBoardPriceIcon.innerHTML = tripBoardPriceIcon;

            const wrappingTripBoardPriceIconHighlighted =
                document.createElement('div');
            wrappingTripBoardPriceIconHighlighted.innerHTML =
                tripBoardPriceIconHighlighted;

            qualifiers[`${uuid}`] = wrappingTripBoardPriceIcon;
            qualifiers[`hl#${uuid}`] = wrappingTripBoardPriceIconHighlighted;

            return;
        });
    }

    if (document) {
        const PROPERTY_LANDING_APP_DESTINATION_CONTAINER =
            document.createElement('div');
        PROPERTY_LANDING_APP_DESTINATION_CONTAINER.innerHTML =
            landingAppDestinationSvg;
        const PROPERTY_LANDING_APP_PRICE_CONTAINER =
            document.createElement('div');
        PROPERTY_LANDING_APP_PRICE_CONTAINER.innerHTML = landingAppPriceSvg;
        const PROPERTY_STANDARD_MARKER_ICON_CONTAINER =
            document.createElement('div');
        PROPERTY_STANDARD_MARKER_ICON_CONTAINER.innerHTML = standardMarkerIcon;
        const PROPERTY_MARKER_ICON_STANDARD_SELECTED =
            document.createElement('div');
        PROPERTY_MARKER_ICON_STANDARD_SELECTED.innerHTML =
            markerIconStandardSelectedSvg;
        const PROPERTY_STANDARD_MARKER_ICON_HOVERED =
            document.createElement('div');
        PROPERTY_STANDARD_MARKER_ICON_HOVERED.innerHTML =
            standardMarkerIconHovered;
        const PROPERTY_CIRCLE_SVG_CONTAINER = document.createElement('div');
        PROPERTY_CIRCLE_SVG_CONTAINER.innerHTML = circleSvg;
        const PROPERTY_CIRCLE_SELECTED_SVG_CONTAINER =
            document.createElement('div');
        PROPERTY_CIRCLE_SELECTED_SVG_CONTAINER.innerHTML = circleSelected;

        qualifiers[landingAppDestination] =
            PROPERTY_LANDING_APP_DESTINATION_CONTAINER;
        qualifiers[pointMarker] = PROPERTY_CIRCLE_SVG_CONTAINER;
        qualifiers[`hl#${pointMarker}`] =
            PROPERTY_CIRCLE_SELECTED_SVG_CONTAINER;
        qualifiers[landingAppPrice] = PROPERTY_LANDING_APP_PRICE_CONTAINER;
        qualifiers[`hl${landingAppPrice}`] =
            PROPERTY_LANDING_APP_PRICE_CONTAINER;
        qualifiers[markerIconStandard] =
            PROPERTY_STANDARD_MARKER_ICON_CONTAINER;
        qualifiers[markerIconStandardSelected] =
            PROPERTY_MARKER_ICON_STANDARD_SELECTED;
        qualifiers[externalHoveredStandardMarkerIcon] =
            PROPERTY_STANDARD_MARKER_ICON_HOVERED;
    }

    const newQualifiers = {
        ...qualifiers,
    };
    return newQualifiers;
};

const placeIconQualifiers = () => {
    if (document) {
        const PLACE_CIRCLE_SVG_CONTAINER = document.createElement('div');
        PLACE_CIRCLE_SVG_CONTAINER.innerHTML = circleSvg;
        const PLACE_CIRCLE_ACTIVE_SVG_CONTAINER = document.createElement('div');
        PLACE_CIRCLE_ACTIVE_SVG_CONTAINER.innerHTML = circleActive;
        const PLACE_CIRCLE_SELECTED_SVG_CONTAINER =
            document.createElement('div');
        PLACE_CIRCLE_SELECTED_SVG_CONTAINER.innerHTML = circleSelected;

        return {
            [pointMarker]: PLACE_CIRCLE_SVG_CONTAINER,
            [`hl#${pointMarker}`]: PLACE_CIRCLE_ACTIVE_SVG_CONTAINER,
            [selectedPointMarker]: PLACE_CIRCLE_SELECTED_SVG_CONTAINER,
            [landingAppPointMarker]: PLACE_CIRCLE_SVG_CONTAINER,
            [`hl#${landingAppPointMarker}`]:
                PLACE_CIRCLE_SELECTED_SVG_CONTAINER,
            [selectedLandingAppPointMarker]:
                PLACE_CIRCLE_SELECTED_SVG_CONTAINER,
        };
    }
    return {};
};

const propertyMarkerActionConfig = (appName) => {
    if (appName === APP_NAMES.TRIPBOARDS) {
        return {
            actionOnClick: {
                default: ['select', 'highlight'],
            },
            actionOnMouseOver: {
                default: [],
            },
            actionOnMouseOut: {
                default: [],
            },
            actionOnFeatureSelect: {
                default: ['select', 'highlight'],
            },
            actionOnFeatureDeselect: {
                default: ['dehighlight', 'closePopup'],
            },
            clustering: {
                type: 'none',
            },
        };
    }

    return {
        actionOnClick: {
            default: ['select', 'highlight'],
        },
        actionOnMouseOver: {
            default: ['highlight'],
        },
        actionOnMouseOut: {
            default: ['dehighlight'],
        },
        actionOnFeatureSelect: {
            default: ['select', 'highlight'],
        },
        actionOnFeatureDeselect: {
            default: ['dehighlight', 'closePopup'],
        },
        clustering: {
            type: 'none',
        },
    };
};

export const cfg = (markers, appName) => {
    const propertyMarkerAction = propertyMarkerActionConfig(appName);
    return {
        property: {
            textLabel: {
                show: {
                    default: 'always',
                },
                position: {
                    default: 'center',
                },
                zIndex: {
                    default: 9,
                },
            },
            popup: {
                ensureVisibility: {
                    default: 'true',
                },
            },
            ...propertyMarkerAction,
            markerType: {
                [landingAppDestination]: 'pin',
                [pointMarker]: 'pin',
                [markerIconStandard]: 'pin',
                [landingAppPrice]: 'pin',
                [markerIconStandardSelected]: 'pin',
            },
            icons: propertyIconQualifiers(markers, appName),
            tagCollidingMarkers: true,
            obfuscateMarkers: {
                style: {
                    default: {
                        line: {
                            weight: 1,
                            color: '#616161',
                            opacity: 1,
                        },
                        fill: {
                            color: '#E6E6E6',
                            opacity: 0.5,
                        },
                    },
                    hl: {
                        line: {
                            weight: 1,
                            color: '#1C598C',
                            opacity: 1,
                        },
                        fill: {
                            color: '#0E77CD',
                            opacity: 0.5,
                        },
                    },
                },
            },
            clustering: {
                default: {
                    type: 'none',
                },
            },
        },
        place: {
            textLabel: {
                show: {
                    default: 'always',
                },
                position: {
                    default: 'center',
                },
                zIndex: {
                    default: 9,
                },
            },
            popup: {
                ensureVisibility: {
                    default: 'true',
                },
            },
            zIndex: {
                default: 1,
                hl: 8,
                available: 7,
                filtered: 4,
                sold_out: 3,
                unknown: 2,
            },
            actionOnClick: {
                default: ['select', 'highlight', 'openPopup'],
            },
            actionOnMouseOver: {
                default: ['highlight', 'sendEvent'],
            },
            actionOnMouseOut: {
                default: ['dehighlightIfNotSelected', 'sendEvent'],
            },
            actionOnFeatureSelect: {
                default: ['select', 'highlight', 'openPopup'],
            },
            actionOnFeatureDeselect: {
                default: ['dehighlight', 'closePopup'],
            },
            actionOnFeatureOver: {
                default: ['highlight'],
            },
            actionOnFeatureOut: {
                default: ['dehighlightIfNotSelected'],
            },
            markerType: {
                [pointMarker]: 'pin',
            },
            icons: placeIconQualifiers(),
            tagCollidingMarkers: true,
        },
    };
};
